<template lang="html">
  <div class="animated fadeIn">
    <b-card>
      <b-button-toolbar class="pull-right">
        <b-btn variant="primary" @click="showAddProduct">Add Product</b-btn>
      </b-button-toolbar>
    </b-card>

    <b-card>
      <v-client-table :columns="columns" :data="products" :options="options" :theme="theme" id="dataTable" ref="dataTable">
        <template slot="enabled" slot-scope="data">
          {{getIsEnabledLable(data.row)}}
        </template>
        <template slot="isvariable" slot-scope="data">
          {{getIsVariableLable(data.row)}}
        </template>
        <template slot="isvisible" slot-scope="data">
          {{getIsVisibleLable(data.row)}}
        </template>

        <template slot="actions" slot-scope="data">
          <b-btn size="sm" variant="outline-primary" @click="showEditProduct(data.row)" class="mr-1">Edit</b-btn>
        </template>
      </v-client-table>
    </b-card>
    <div>
      <b-modal ref="modalEditProduct" title="Edit Product" hide-footer @hide="hideEditProduct">
        <product-edit v-if="selectedProduct"  :systemid="systemid" :selectedProduct="selectedProduct" @success="editProductSuccess" @cancel="cancelEditProduct" />
      </b-modal>
    </div>
    <div>
      <b-modal ref="modalAddProduct" title="Add Product" hide-footer >
        <product-add @success="addProductSuccess" @cancel="cancelAddProduct" :systemid="systemid" />
      </b-modal>
    </div>
  </div>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import Vue from 'vue'
  import ProductEdit from './ProductEdit'
  import ProductAdd from './ProductAdd'
  import filter from 'lodash/filter'


  export default {
    name: 'ProductList',
    props: {
      systemid: {
        type: Number,
        default: null,
      },
    },
    components: {
      ProductEdit,
      ProductAdd
    },

    data: function() {
      return {

        selectedProduct: Object,
        columns: ['name','barcode', 'costprice', 'price', 'isvariable', 'isvisible','enabled', 'stock_in_hand','actions'],
        options: {
          headings: {
            costprice: 'Cost Price',
            price: 'Sell Price',
            isvariable: 'Variable Price?',
            isvisible: 'Product Visible?',
            enabled: 'Enabled?',
            stock_in_hand: 'Stock In Hand'
          },
          sortable: ['name'],
          filterable: ['name', 'barcode', 'costprice', 'sellprice'],
          sortIcon: {
            base: 'fa',
            up: 'fa-sort-asc',
            down: 'fa-sort-desc',
            is: 'fa-sort'
          },
          pagination: {
            chunk: 5,
            edge: true,
            nav: 'scroll'
          },
          perPage: 25,

        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
      }
    },
    computed: {
      products(){
        let systemid = this.systemid;
        return filter(this.$store.state.pos.products,
           function(prd) {
             return (prd.systemid == systemid);
        });
      }
    },
    methods: {
      showAddProduct(){
        this.$refs.modalAddProduct.show();
      },
      cancelAddProduct() {
        this.$refs.modalAddProduct.hide()
      },
      addProductSuccess(product) {
        this.$refs.modalAddProduct.hide();
        this.$store.dispatch('pos/getProducts')
      },
      getIsEnabledLable(prd){
         return prd.enabled == 1 ? 'Yes' : 'No';
      },
      getIsVariableLable(prd){
         return prd.isvariable == 1 ? 'Yes' : 'No';
      },
      getIsVisibleLable(prd){
         return prd.isvisible == 1 ? 'Yes' : 'No';
      },
      showEditProduct(prd) {
        this.selectedProduct = prd
        this.$refs.modalEditProduct.show()
      },
      cancelEditProduct() {
        this.$refs.modalEditProduct.hide()
      },
      editProductSuccess() {
        this.$refs.modalEditProduct.hide();
        this.$store.dispatch('pos/getProducts')
      },
      hideEditProduct() {
        this.selectedProduct = null
      },
    },
    created() {
      if (this.$store.state.pos.products.length == 0) {
        this.$store.dispatch('pos/getProducts');
      }
    }
  }
</script>

<style lang="css">
</style>
